module.exports = __webpack_public_path__ + "static/media/sontho-3.7b5f36ba.png";